<template>
  <footer>
    <div class="container">
      <div class="row">
        <div class="col">
          &copy; 2024 AEDIL AS. All rights reserved.
        </div>
<!--         <div class="col text-right">
          Website designed and developed by <a href="https://originalone.in" target="_blank">Original One</a>.
        </div> -->
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'CustomFooter'
}
</script>

